"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _uuid = require("uuid");
var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));
var _constants = require("./lib/constants");
class StepTemplatesApi extends _basic_data_hub_api.default {
  async getStepTemplates(_ref) {
    let {
      query = {},
      projection,
      forceSandbox,
      limit,
      offset,
      group,
      sandbox
    } = _ref;
    if (query.sourceId === '') {
      delete query.sourceId;
      forceSandbox = true;
    }
    if (query.sourceId) {
      query.flowId = query.sourceId;
      delete query.sourceId;
    }
    return this._callApi({
      path: `/step-templates`,
      queryParams: {
        projection,
        query,
        sandbox: forceSandbox || sandbox,
        limit,
        offset,
        group
      }
    });
  }
  async getStepTemplatesByToken(_ref2) {
    let {
      query = {},
      projection,
      limit,
      token,
      forceSandbox = false
    } = _ref2;
    const binding = await this.getBinding();
    return binding.query.listTemplates({
      entity: _constants.STEP_TEMPLATE,
      params: {
        queryParams: query,
        limit,
        last: token
      },
      sourceId: query.sourceId,
      forceSandbox
    }, projection || ['records', 'last']);
  }
  async getStepTemplateById(id) {
    let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let projection = arguments.length > 2 ? arguments[2] : undefined;
    let sandbox = arguments.length > 3 ? arguments[3] : undefined;
    query.id = id;
    const [step] = await this.getStepTemplates({
      query,
      projection,
      sandbox
    });
    return step;
  }
  getRawStepTemplateById(id) {
    let sandbox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return this.getStepTemplateById(id, undefined, undefined, sandbox);
  }

  /**
   * Copy step to flow
   * @param {(string|{step: Object, flowId: string})} options Step ID or object with `id`, `version`, `isExternal` and `isSandbox` keys.
   * @param {string} destFlowId Destination Flow ID
   * @returns {Promise}
   */
  async copyToFlow(options, destFlowId) {
    const stepId = (0, _get2.default)(options, 'step.id', options);
    const flowId = (0, _get2.default)(options, 'flowId', destFlowId);
    const externalStep = (0, _get2.default)(options, 'step.isExternal') && options.step;
    return this._callApi({
      method: 'put',
      path: `/step-templates/${flowId}`,
      payload: {
        stepId,
        externalStep
      }
    });
  }

  /**
   * Get step-templates by flowId
   * @param {({
   *   scope: { flowId: string },
   *   query: string,
   *   size: string,
   *   cursor: string
   * })} options req options object.
   * @returns {Promise}
   */
  async getStepTemplatesByFlowId(options) {
    const flowId = (0, _get2.default)(options.scope, 'flowId');
    return this._callApi({
      method: 'get',
      path: `/step-templates/${flowId}`,
      queryParams: {
        query: options.query ? {
          label: options.query
        } : undefined,
        offset: (0, _get2.default)(options, 'cursor.offset'),
        limit: (0, _get2.default)(options, 'size'),
        isCustom: (0, _get2.default)(options, 'isCustom')
      }
    });
  }
  async getMostDownloaded(_ref3) {
    let {
      pagination = {
        limit: 1000
      },
      sort,
      projection
    } = _ref3;
    const binding = await this.getBinding();
    return binding.query.getDownloads({
      type: _constants.STEP,
      pagination,
      sort
    }, projection);
  }
  static getNewStepTemplate(stepId) {
    return {
      id: stepId || (0, _uuid.v4)(),
      // this won't change in a future versions of a step
      version: '0.0.1',
      cacheVersion: (0, _uuid.v4)(),
      // this will change every time you save a step template
      label: '',
      icon: '',
      iconType: 'default',
      iconUrl: '',
      shape: 'circle',
      description: '',
      dateCreated: Date.now(),
      dateModified: Date.now(),
      publishedBy: '',
      template: `/* Your custom logic goes here. */
// This exits the step down the exit leg labeled \`next\`
return this.exitStep('next' /*, outputData */ );
//  This second argument is optional output data, which
//  will be stored in the step's merge field upon exit.`,
      categories: [],
      form: {
        style: '',
        template: '',
        code: ''
      },
      data: {
        exits: []
      },
      modules: [],
      reporting: {
        step: {
          label: 'Step',
          type: 'step',
          enabled: true,
          tags: []
        }
      },
      outputExample: null,
      formBuilder: {
        stepExits: [{
          component: 'exitStatic',
          data: {
            id: 'next',
            label: 'next'
          }
        }],
        stepInputs: [],
        hasDataOut: false,
        hasProcessError: false,
        outputExample: null
      },
      rawMode: false,
      hooks: null
    };
  }
}
var _default = StepTemplatesApi;
exports.default = _default;